import React, { useEffect } from 'react';
import { Helmet } from "react-helmet-async";
import { Award, BookOpen, CheckCircle, Clock, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function CertificateContent() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="py-5" style={{ background: '#f8fafc', minHeight: '85vh' }}>
      <Helmet>
        <title>Certificate in Theology - Vidyajyoti College of Theology</title>
        <meta name="description" content="One or two-year Certificate in Theology at Vidyajyoti College of Theology, Delhi." />
        <meta name="keywords" content="Certificate in Theology, Theology Certificate Delhi, Catholic Short Courses, Vidyajyoti" />
        <link rel="canonical" href="/academics/certificate" />
      </Helmet>

      <div className="container">
        {/* Header Hero */}
        <div className="card border-0 rounded-4 shadow-sm p-4 p-md-5 mb-5" style={{ background: 'linear-gradient(135deg, #1a2b56 0%, #2a3f75 100%)', color: '#fff' }}>
          <div className="row align-items-center">
            <div className="col-lg-8">
              <div className="d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill mb-3" style={{ background: 'rgba(198, 146, 20, 0.2)', color: '#ffd56b', fontSize: '0.85rem', fontWeight: 600 }}>
                <Sparkles size={14} /> Certificate Programme
              </div>
              <h1 className="display-6 fw-bold mb-2" style={{ fontFamily: "'Outfit', sans-serif" }}>
                Certificate in Theology
              </h1>
              <p className="lead mb-0 text-light" style={{ fontSize: '1.02rem', lineHeight: '1.7', opacity: 0.9 }}>
                Short-term certificate courses offered over 1 or 2 academic years for men and women religious, pastoral ministers, and laity seeking modular theological enrichment.
              </p>
            </div>
            <div className="col-lg-4 text-center mt-4 mt-lg-0">
              <div className="p-4 rounded-4" style={{ background: 'rgba(255, 255, 255, 0.08)', backdropFilter: 'blur(10px)', border: '1px solid rgba(255, 255, 255, 0.15)' }}>
                <Award size={40} className="mb-2" style={{ color: '#ffd56b' }} />
                <h5 className="fw-bold mb-1 text-white">1 - 2 Years</h5>
                <p className="small mb-0 text-light opacity-75">~30 Credits Per Year</p>
                <hr style={{ borderColor: 'rgba(255,255,255,0.2)' }} />
                <Link to="/admission/details" className="btn btn-sm w-100 rounded-pill fw-semibold text-white" style={{ background: '#79031d' }}>
                  Admission Guidelines
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Feature Highlights */}
        <div className="row g-4">
          <div className="col-md-6">
            <div className="card h-100 border-0 rounded-4 shadow-sm p-4 p-md-5 bg-white">
              <div className="d-flex align-items-center gap-3 mb-3">
                <div className="p-3 rounded-circle" style={{ background: 'rgba(26,43,86,0.08)', color: '#1a2b56' }}>
                  <BookOpen size={24} />
                </div>
                <h4 className="fw-bold mb-0" style={{ color: '#1a2b56' }}>Course Structure</h4>
              </div>
              <p className="text-muted" style={{ lineHeight: '1.8', textAlign: 'justify' }}>
                Students take tailored courses for one or two years (First and Second Year Certificates). A total of about 30 credits per year is required. Courses are selected under the guidance of an assigned faculty mentor designated by the Principal.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="card h-100 border-0 rounded-4 shadow-sm p-4 p-md-5 bg-white">
              <div className="d-flex align-items-center gap-3 mb-3">
                <div className="p-3 rounded-circle" style={{ background: 'rgba(121,3,29,0.08)', color: '#79031d' }}>
                  <Clock size={24} />
                </div>
                <h4 className="fw-bold mb-0" style={{ color: '#79031d' }}>Eligibility &amp; Flexibility</h4>
              </div>
              <ul className="list-unstyled d-flex flex-column gap-3 mb-0">
                <li className="d-flex align-items-start gap-2">
                  <CheckCircle size={18} className="text-success flex-shrink-0 mt-1" />
                  <span className="text-muted small">Open to all duly qualified clerical, religious, and lay students.</span>
                </li>
                <li className="d-flex align-items-start gap-2">
                  <CheckCircle size={18} className="text-success flex-shrink-0 mt-1" />
                  <span className="text-muted small">Tailored elective pathways spanning Scripture, Pastoral Care, and Ethics.</span>
                </li>
                <li className="d-flex align-items-start gap-2">
                  <CheckCircle size={18} className="text-success flex-shrink-0 mt-1" />
                  <span className="text-muted small">Formal Certificate in Theology conferred upon completion of required credits.</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
